import {QuickAddModal} from '@/scripts/optional/quick-add';
import { TsDOM as q} from '@/scripts/core/TsDOM'
import { ProductForm } from '@/scripts/product/product-form';
q.safeDefineElement(QuickAddModal);
q.safeDefineElement(ProductForm)
